import {NgModule} from '@angular/core';
import {LoginComponent} from './login/';
import {AuthRoutingModule} from './auth-routing.module';
import {AuthComponent} from "./auth.component";
import {SharedModule} from "../shared/shared.module";

@NgModule({
    imports: [
        AuthRoutingModule,
        SharedModule
    ],
    declarations: [
        LoginComponent,
        AuthComponent
    ],
    providers: [
    ]
})
export class AuthModule {}



// WEBPACK FOOTER //
// /code/frontend/src/app/auth/auth.module.ts